import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export interface Feeling {
  id: string;
  name: LocalizedString;
  description?: LocalizedString;
  emoji?: string;
  iconUrl?: string;
  oppositeOfIds: string[];
  position: number;
  isPositive: boolean;
}

export function feelingFromJson(json: Record<string, unknown>): Feeling {
  return {
    id: json['id'] as string,
    name: localizedStringFromMap(json['name'] as Record<string, unknown>),
    description: json['description'] != null
      ? localizedStringFromMap(json['description'] as Record<string, unknown>)
      : undefined,
    emoji: json['emoji'] as string | undefined,
    iconUrl: json['iconUrl'] as string | undefined,
    oppositeOfIds: (json['oppositeOf'] as string[] | undefined) ?? [],
    position: json['position'] as number,
    isPositive: json['isPositive'] as boolean,
  };
}
